import settings from '../game/assets/settings.es6';

export default class Appdata{

    constructor() {
        this.init();
    }


    init(){
        this.app_id = '/chu5/2022pregame';
        this.debug();
    }


    read(){
        //need js-cookie.js

        return {
            playlimit: Cookies.get(this.app_id + 'playlimit') || settings.playLimit,
            score: Cookies.get(`${this.app_id}score`) ? JSON.parse(Cookies.get(`${this.app_id}score`)) : undefined,
            mute: Cookies.get(this.app_id + 'mute') || '0',
            login: Cookies.get(this.app_id + 'login') || '',
        };
    }


    save(data){
        //当日23:59まで保持するクッキー
        const date = new Date();
        const endofday = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59);

        if (data.playlimit !== undefined) {
            Cookies.set(this.app_id + 'playlimit', data.playlimit, { expires: endofday });
        }

        if (data.score !== undefined) {
            Cookies.set(`${this.app_id}score`, JSON.stringify(data.score), { expires: endofday });
        }

        if (data.mute !== undefined) {
            Cookies.set(this.app_id + 'mute', data.mute, { expires: endofday });
        }

        if (data.login !== undefined) {
            Cookies.set(this.app_id + 'login', data.login, { expires: endofday });
        }
    }
    

    debug(){

        $('.js-debug').on('click', () => {
            Cookies.remove(this.app_id + 'playlimit');
            Cookies.remove(this.app_id + 'login');
            location.reload();
        });
    }
}
